import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const EnvGuard: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const env = localStorage.getItem("env");
    const runtimeEnv = window.location.hostname;
    const buildEnv = import.meta.env.VITE_APP_ENV;
    const API_URL_GETDATA = import.meta.env.VITE_API_URL;

    console.log("✅ API URL:", API_URL_GETDATA);
    console.log("LocalStorage env:", env);
    console.log("Runtime hostname:", runtimeEnv);
    console.log("Build-time VITE_APP_ENV:", buildEnv);

    if (env && env !== runtimeEnv) {
      console.warn("❌ Environment mismatch detected. Logging out.");
      localStorage.clear();
      navigate("/login", { replace: true });
    }

    if (!env) {
      localStorage.setItem("env", runtimeEnv);
    }
  }, [navigate]);

  return null;
};

export default EnvGuard;
